import { useState, useCallback } from 'react';

export const useAllImagesLoaded = ((totalCount: number) => {
    const [loadedCount, setLoadedCount] = useState(0);

    const onLoad = useCallback(() => {
        setLoadedCount((prev) => prev + 1);
    }, []);

    const allLoaded = totalCount > 0 && loadedCount === totalCount;

    return { onLoad, allLoaded, loadedCount };
})